import { Box } from '@mui/material';
import { ReactNode, useState } from 'react';
import { DynamicIcon, EntityOpenModeSwitcher, Tooltip } from 'src/components';
import { BlockContainer, BlockHeader } from 'src/components/Layout/named-layout-block.view';
import { RecordOpenMode } from 'src/graphql';
import { PeekColumn, PeekToolsSlot } from './entity-peek.elements';

interface SearchEntityPeekHostProps {
  menu?: ReactNode;
  onOpenFullPage?: () => void;
  onClose: () => void;
  closeTooltip: string;
  children: (toolsSlot: HTMLElement | null) => ReactNode;
}

// The side panel is a bare card column, so this host owns the chrome, the scroller
// and the sticky slot the floating personalize tool portals into.
export const SearchEntityPeekHost = ({
  menu,
  onOpenFullPage,
  onClose,
  closeTooltip,
  children,
}: SearchEntityPeekHostProps) => {
  const [toolsSlot, setToolsSlot] = useState<HTMLElement | null>(null);

  return (
    <BlockContainer>
      <BlockHeader sx={{ justifyContent: 'flex-end' }}>
        {onOpenFullPage ? (
          <EntityOpenModeSwitcher
            openMode={RecordOpenMode.FullPage}
            onClick={onOpenFullPage}
          />
        ) : null}
        {menu}
        <Tooltip title={closeTooltip}>
          <DynamicIcon name="right_panel_close" sx={{ cursor: 'pointer' }} onClick={onClose} />
        </Tooltip>
      </BlockHeader>
      {/* the header sits in flow here (not as a glass overlay), so the column takes the
          remaining height instead of the full one */}
      <PeekColumn sx={{ flex: 1, minHeight: 0, height: 'auto' }}>
        {/* same insets as the peek host, minus its glass-header offset, so the floating
            tool keeps the peek's distance to the first card and to the card's right edge */}
        <PeekToolsSlot ref={setToolsSlot} sx={{ top: '0.625rem' }} />
        <Box sx={{ pt: '0.5rem', pr: '0.25rem', pb: '0.5rem' }}>{children(toolsSlot)}</Box>
      </PeekColumn>
    </BlockContainer>
  );
};
